var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'f-tabs': true,
    'f-tabs-vertical': _vm.tabsVertical,
    'is-readonly': _vm.readonly,
    'f-tabs-small': !_vm.tabsVertical && _vm.small,
  }},[_c('div',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.away),expression:"away"}],class:{
      'f-tabs-header': true,
      'f-tabs-header-extended': _vm.extendedHeader,
      'is-open': _vm.mobileTabHeaderVisible
    }},[_c('div',{class:{
        'wrapper': !_vm.tabsVertical,
        'f-tabs-header-content': true
      }},[_c('ul',{staticClass:"f-tabs-list"},_vm._l((_vm.filteredItems),function(item,index){return _c('li',{key:index,class:{
            'f-tabs-list-item': true,
            'active': item === _vm.activeItem,
            'is-completed': item.completed === true,
            'is-invalid': item.invalid === true,
            'is-not-completed': item.completed === false,
            'is-data-loading': item.completed === 'loading',
            'text-danger' : item.theme === 'danger'
          },attrs:{"data-counter":item.counter},on:{"click":function($event){return _vm.triggerTabAction(item)}}},[(item.title)?_c('span',{class:{
              'title': true,
              'hidden-mobile': item.titleMobile
            }},[_vm._v(" "+_vm._s(item.title)+" ")]):_vm._e(),(item.titleMobile)?_c('span',{staticClass:"title hidden-desktop-only-inline"},[_vm._v(_vm._s(item.titleMobile))]):_vm._e(),(item.showCounter)?_c('span',{class:{
              'counter': true,
              'counter-danger': item.messagesNotRead
            }},[_vm._v(" "+_vm._s(item.counter)+" ")]):_vm._e(),(!_vm.readonly && _vm.tabsVertical && _vm.withCompletion)?_c('span',{staticClass:"progress"}):_vm._e()])}),0),(_vm.extendedHeader)?_c('div',{staticClass:"tab-header-additional flex flex-align-items-center ml-auto full-height"},[_vm._t("tab-header")],2):_vm._e()]),(_vm.tabsVertical)?_c('div',{attrs:{"id":"tabsHeaderToggle"},on:{"click":function($event){$event.preventDefault();return _vm.handleToggleTabHeader()}}}):_vm._e()]),_c('div',{class:{
      'f-tabs-elements': true,
      'wrapper': !_vm.tabsVertical,
      'mt-2': !_vm.tabsVertical}},_vm._l((_vm.filteredItems),function(item,index){return _c('div',{key:index,class:{
        'f-tabs-elements-item': true,
        'active': item === _vm.activeItem
      }},[_vm._t('tab-' + index)],2)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }